import React, { Suspense } from "react";

export const RouteFallback = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
    <span aria-live="polite">Loading…</span>
  </div>
);

export function LazyRoute({ Component }) {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Component />
    </Suspense>
  );
}

export const withSuspense = (LazyComponent) => <LazyRoute Component={LazyComponent} />;
